import Marquee from "react-fast-marquee";
import { componentStyles } from "./marquee-cards-grid-component.scss";
import MarqueeProductCard from "./marquee-product-card/marquee-product-card";

const MarqueeCardsGridComponent = (props) => {
  const { cards } = props;
  return (
    <div className="marquee-cards-grid-component">
      <Marquee speed={50} pauseOnHover={true}>
        {cards.map((card) => {
          return <MarqueeProductCard card={card} />;
        })}
      </Marquee>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default MarqueeCardsGridComponent;
